const DEFAULT_INTERVAL = 6000;

export const initServiceSliders = () => {
  const sliders = [...document.querySelectorAll(".js-service-slider")];

  for (const slider of sliders) {
    const slides = [...slider.querySelectorAll(".js-service-slide")];
    const control = slider.querySelector(".js-service-slider-control");

    if (slides.length < 2 || !control) {
      continue;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const interval = Number(slider.dataset.slideInterval) || DEFAULT_INTERVAL;
    let currentIndex = 0;
    let timerId;
    let isUserPaused = reduceMotion.matches;

    const showSlide = (nextIndex) => {
      slides[currentIndex].classList.remove("is-current");
      slides[currentIndex].setAttribute("aria-hidden", "true");
      currentIndex = nextIndex;
      slides[currentIndex].classList.add("is-current");
      slides[currentIndex].setAttribute("aria-hidden", "false");
    };

    const stopTimer = () => {
      window.clearInterval(timerId);
      timerId = undefined;
    };

    const startTimer = () => {
      stopTimer();

      if (isUserPaused || document.hidden) {
        return;
      }

      timerId = window.setInterval(() => {
        showSlide((currentIndex + 1) % slides.length);
      }, interval);
    };

    const updateControl = () => {
      control.setAttribute("aria-pressed", String(isUserPaused));
      control.setAttribute(
        "aria-label",
        isUserPaused ? "スライドショーを再生" : "スライドショーを停止",
      );
    };

    control.addEventListener("click", () => {
      isUserPaused = !isUserPaused;
      updateControl();
      startTimer();
    });

    document.addEventListener("visibilitychange", startTimer);
    reduceMotion.addEventListener("change", (event) => {
      isUserPaused = event.matches;
      updateControl();
      startTimer();
    });

    updateControl();
    startTimer();
  }
};
